import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "assets",
  "use": "assets-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\" id=\"assets\"><path d=\"M0 9h16v3H0zM0 0v7.53h16V0zm14.94 3.08h-3V1.69h3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id